export default function initScripts(){
    // Mobile menu functionality
    const menuBtn = document.querySelector('.menu-btn');
    const drawer = document.getElementById('drawer');
    const drawerOverlay = document.getElementById('drawerOverlay');
    const drawerClose = document.getElementById('drawerClose');

    function openDrawer() {
        drawer.classList.add('active');
        drawerOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        drawer.classList.remove('active');
        drawerOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    menuBtn.addEventListener('click', openDrawer);
    drawerClose.addEventListener('click', closeDrawer);
    drawerOverlay.addEventListener('click', closeDrawer);

    // Close drawer when clicking on drawer items
    document.querySelectorAll('.drawer-item').forEach(item => {
        item.addEventListener('click', function(e) {
           closeDrawer();
           
        });
    });

    // Close drawer on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('active')) {
            closeDrawer();
        }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && drawer.classList.contains('active')) {
            closeDrawer();
        }
    });

    // Search functionality
    document.querySelector('.search-box').addEventListener('input', function(e) {
        const query = e.target.value.toLowerCase();
        // Add search logic here
        console.log('Searching for:', query);
    });

    // Game card click handlers
    // document.querySelectorAll('.game-card').forEach(card => {
    //     card.addEventListener('click', function() {
    //         console.log('Game card clicked:', this.querySelector('.game-title').textContent);
    //         // Add navigation to game details
    //     });
    // });

    // Category click handlers
    // document.querySelectorAll('.category-card').forEach(category => {
    //     category.addEventListener('click', function() {
    //         console.log('Category clicked:', this.querySelector('.category-name').textContent);
    //         // Add navigation to category page
    //     });
    // });

    // Navigation items synchronization
    // document.querySelectorAll('.nav-item').forEach(item => {
    //     item.addEventListener('click', function(e) {
    //         e.preventDefault();
            
    //         // Remove active class from all nav items
    //         document.querySelectorAll('.nav-item').forEach(i => i.classList.remove('active'));
    //         // Add active class to clicked item
    //         this.classList.add('active');
            
    //         // Update drawer items based on selection
    //         const itemText = this.textContent.trim();
    //         document.querySelectorAll('.drawer-item').forEach(drawerItem => {
    //             drawerItem.classList.remove('active');
    //             if (drawerItem.textContent.trim() === itemText) {
    //                 drawerItem.classList.add('active');
    //             }
    //         });
            
    //         console.log('Navigating to:', itemText);
    //     });
    // });

    // Smooth scrolling for horizontal sections
    document.querySelectorAll('.horizontal-scroll').forEach(scroll => {
        let isDown = false;
        let startX;
        let scrollLeft;

        scroll.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - scroll.offsetLeft;
            scrollLeft = scroll.scrollLeft;
        });

        scroll.addEventListener('mouseleave', () => {
            isDown = false;
        });

        scroll.addEventListener('mouseup', () => {
            isDown = false;
        });

        scroll.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scroll.offsetLeft;
            const walk = (x - startX) * 2;
            scroll.scrollLeft = scrollLeft - walk;
        });
    });

    // Add loading animation for game cards
    function addLoadingEffect() {
        document.querySelectorAll('.game-card').forEach((card, index) => {
            card.style.opacity = '0';
            card.style.transform = 'translateY(20px)';
            
            setTimeout(() => {
                card.style.transition = 'all 0.5s ease';
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
            }, index * 100);
        });
    }

    // Initialize loading effect
    window.addEventListener('load', addLoadingEffect);

    // Responsive navigation scroll
    function updateNavScroll() {
        const activeItem = document.querySelector('.nav-item.active');
        
        if (activeItem && window.innerWidth <= 768) {
            activeItem.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });
        }
    }

    // Call on window resize
    window.addEventListener('resize', updateNavScroll);
}